import { LocalStorage } from 'quasar';

export function setUser({ commit }, value) {
  commit('setUser', value);
}
export function setHighlights({ commit, dispatch }, value) {
  commit('setHighlights', value);
  dispatch('saveSettings');
}

export function getSettings({ commit }) {
  let settings = LocalStorage.getItem('settings');
  if (settings) {
    commit('setSettings', settings);
  }
}

export function saveSettings({ state }) {
  LocalStorage.set('settings', state.settings);
}

export function addInsights({ commit }, value) {
  commit('addInsights', value);
}
